<template>
    <div class="chat-textinput--wrapper">
        <i class="chat-textinput--icon" :style="{ backgroundImage: 'url(' + require('@/assets/search-24px.svg') + ')' }"></i>
        <input :value="text"
               @input="$emit('update:text', $event.target.value)"
               :placeholder="$t('people') + ' , ' + $t('groups').toLowerCase()"
               class="chat-textinput--input" type="text">
    </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    text: String
  }
}
</script>

<style lang="scss">
.chat-textinput--wrapper {
    position: relative;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    .chat-textinput--icon {
        position: absolute;
        width: 20px;
        height: 20px;
        color: white;
        background-size: cover;
        top: 2px;
        bottom: 0;
        margin: auto;
        fill: cadetblue;
        margin-left: 5px;
    }
    .chat-textinput--input {
        width: 100%;
        height: 100%;
        padding-left: 24px;
        border: 1px solid lightgray;
        border-radius: 4px;
        box-sizing: border-box;
    }
}
</style>
